import axios from 'axios'
let Base64 = require('js-base64').Base64;
// import { Toast } from 'vant';
// import qs from "qs";

const imgUpload = async (file) => {
    const formData = new FormData()
    formData.append("file", file)
    const url = 'https://bigozb.cn/api/system/img_upload'
    const token = localStorage.getItem('token')
    if (!token) return
    const lang = localStorage.getItem("lang").toLowerCase() || 'en_us'
    const headers = {
        'Content-Type': 'multipart/form-data',
        token: Base64.encode(token),
        lang: lang,
    }

    const res = await axios.post(url, formData, { headers })
    const imgPath = JSON.parse(Base64.decode(res.data.data)).img_path;

    return imgPath
}

export default imgUpload

